(function ($, ns) {
    'use strict';

    var cfg = {
        cache: {
            container: '[data-component="Dom.ProductImageCarousel"]',
            productCarousel: '.product-carousel',
            slides: '> li, > .product-carousel-item',
            lightboxItem: '> a',
            html: 'html',
            carouselImages: '.carousel-img',
            asyncImage: 'img[data-src]',
        },
        classes: {
            faded: 'faded',
        },
        events: {
            click: 'click',
            resize: 'resize',
            load: 'load',
            touchstart: 'touchstart',
            touchend: 'touchend',
        },
        options: {
            nextText: '',
            prevText: '',
            mode: 'horizontal',
            pager: false,
            infiniteLoop: true,
            touchEnabled: true,
        },
    };

    ns.ProductImageCarousel = function (container) {
        this.container = container;
        this.settings = cfg;
        this.init();
    };

    ns.ProductImageCarousel.prototype = {
        init: function () {
            this.cacheItems();

            if (!this.html.hasClass('page-edit') && this.container.length) {
                this.activate();
            }
        },
        cacheItems: function () {
            var cache = this.settings.cache;

            this.win = $(window);
            this.html = $(cache.html);

            this.slides = this.container.find(cache.slides);
            this.lightboxItems = this.slides.find(cache.lightboxItem);
            this.productCarousel = this.container.closest(cache.productCarousel);
        },
        activate: function () {
            var settings = this.settings,
                options = settings.options,
                classes = settings.classes,
                events = settings.events;

            if (this.container.data('carousel-mode')) {
                options.mode = this.container.data('carousel-mode');
            }

            // Add a preload when a slide is clicked before all images got loaded;
            // options.onSlideBefore = element => {
            //     this.slideBefore(element);
            // };
            // this.slideBefore(this.slides.eq(0));

            if (this.slides.length > 1) {
                this.bxSlider = this.container.bxSlider(options);

                // After timeout init all images
                setTimeout(() => {
                    this.loadImages();
                }, 200);
            }

            // Activate the lightbox when bigger then 991px
            if (this.win.width() > 991) {
                // activate lightbox gallery
                this.lightboxItems.magnificPopup({
                    gallery: {
                        enabled: true,
                    },
                    type: 'image',
                    callbacks: {
                        open: () => {
                            // Will fire when this exact popup is opened
                            // this - is Magnific Popup object
                            this.productCarousel.addClass(classes.faded);
                        },
                        close: () => {
                            // Will fire when popup is closed
                            this.productCarousel.removeClass(classes.faded);
                        },
                    },
                });
            } else {
                this.lightboxItems.on(events.click, () => {
                    return false; // disabled click event on mobile to disable lightbox;
                });
            }
        },
        // slideBefore: function(element) {
        //     let settings = this.settings,
        //         cache = settings.cache,
        //         asyncImages = element.find(cache.asyncImage);

        //     for (let i = 0; i < asyncImages.length; i++) {
        //         ns.fn.loadImageAsync(asyncImages.eq(i)[0]);
        //     }

        //     return true;
        // },
        loadImages: function () {
            let settings = this.settings,
                cache = settings.cache,
                asyncImages = this.container.find(cache.asyncImage);

            let promises = [];

            for (let i = 0; i < asyncImages.length; i++) {
                promises.push(ns.fn.loadImageAsync(asyncImages.eq(i)[0]));
            }

            // Reload slider when all images loaded
            Promise.all(promises).then(() => {
                this.bxSlider.reloadSlider();
            });

            return true;
        },
    };

    return ns;
})(window.jQuery, window.Dom || {});
